module.exports = __webpack_public_path__ + "img/reportChicken_8.2ac5a898.png";